import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './global.css';
import App from './App';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: 'https://34b337a6a5fc5739e955c34ae750bf8b@o132359.ingest.us.sentry.io/4510825297084416',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
